import systemSettingApi from '@/api/system-setting'
import store from '@/store'
import { generateFormHandlerMutations } from '@/helpers/forms'

const getDefaultState = () => ({
  prefix: '',
  timeConst: 0,
  cardConst: 0,
  errors: {
    errors: [],
    commonErrors: []
  },
})

const state = getDefaultState()

const getters = {}

const actions = {
  fetch({ commit }) {
    commit("FORM_RESET");
    systemSettingApi.getQrCodeSetting()
      .then(({ data }) => commit('QR_CODE_SETTING_FETCHED', data))
      .catch(err => commit('QR_CODE_SETTING_FETCH_FAILED', err))
  },
  update({ commit }) {
    return systemSettingApi.updateQrCodeSetting(state)
      .then(({ data }) => commit('QR_CODE_SETTING_UPDATED', data))
      .catch((error) => {
        commit('QR_CODE_SETTING_UPDATE_FAILED', error.response.data)
        throw error;
      })
  },
  resetForm({ commit }) {
    commit("FORM_RESET")
  },
}

const mutations = {
  QR_CODE_SETTING_UPDATED() {
    store.dispatch('message/success', 'APPLICATION_DESCRIPTION.updated')
  },
  QR_CODE_SETTING_UPDATE_FAILED(state, errors) {
    Object.assign(state.errors, errors)
    store.dispatch('message/error', 'APPLICATION_DESCRIPTION.failedUpdate')
  },
  FORM_RESET(state) {
    Object.assign(state, getDefaultState())
  },
  QR_CODE_SETTING_FETCHED(state, data) {
    Object.assign(state, data)
  },
  ...generateFormHandlerMutations(state)
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
